import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Form } from "react-bootstrap";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { getApiCall, postApiCall } from "../../../service/httpCall"; // Replace with your API call service
import Loader from '../../../components/partials/components/loader';
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { API_PROMPT_ACTIVE_LIST, API_PROMPTS_LIST } from "../../../service/url";
import "../../../assets/custom/css/custom.css";
import { BACKEND_API_BASE_URL } from "../../../utilities/constant";
import "./index.css"
import { PROMPT_STATUS, USER_ROLES, MODULE_ACL } from "../../../utilities/constant";
import { Toaster } from 'react-hot-toast';
import LottieAnimation from '../../../components/lottie/lottie';
import Modal from "react-bootstrap/Modal";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { DeleteIcon } from "../../../components/setting/elements";
import RenderDeleteModal from "../../../components/partials/components/delete-modal";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import exportData from "../../../utilities/export";
import { getUser } from "../../../utilities/setting";


const ManagePrompts = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [reloadTrigger, setReloadTrigger] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); 
  const [audioUrl, setAudioUrl] = useState("");
  const [showToastModal, setShowToastModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [selectedData, setSelectedPrompt] = useState([]);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [deletePromptId, setDeletePromptId] = useState(undefined);
  const [enableDeleteModal, setEnableDeleteModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [isSuperAdmin, setIsSuperadmin] = useState(false)

   useEffect(() => {
      getUser().then((user) => {
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      });
   }, []);

useEffect(() => {
  fetchPrompts();
}, [reloadTrigger]);

const fetchPrompts = () => {
  setLoading(true);
  getApiCall(`${API_PROMPT_ACTIVE_LIST}`)
    .then(onPromptsSuccess)
    .catch(onError)
    .finally(() => setLoading(false));
};

  const showToasts = (message) => {
    setToastMessage(message);
    setShowToastModal(true);

    // Hide modal automatically after 3 seconds
    setTimeout(() => {
        setShowToastModal(false);
    }, 3000);
  };

  useEffect(() => {
    if(searchValue){
      setPrompts(
        prompts.filter((data) => data.prompt_name.toLowerCase().includes(searchValue.trim().toLowerCase()))
      );
    }
    else {
      setPrompts(originalDataList);
    }
  }, [searchValue, prompts]);


  
      //  useEffect(() => {
      //       if (toastProps) {
      //           setShowToast(true);
      //       }
      //   }, [toastProps]);

  const onPromptsSuccess = (resp) => {
    const updatedList = resp.map((item, index) => ({
      ...item,  
      key: index + 1,
      id: item.id,
      status: item.prompt_status == 0 
        ? "Pending" 
        : item.prompt_status == 1 
        ? "Approved" 
        : "Rejected",
    }));
    setPrompts(updatedList);
    setOriginalDataList(updatedList)
  };



  const handleApprove = (id) => {
    const payload = {
        status: PROMPT_STATUS.APPROVED
    };

    postApiCall(`/v2/prompt/${id}`, payload)
        .then((data) => {
            showToasts("Audio Approved");
             
            setPrompts((prevPrompts) =>
                prevPrompts.map((prompt) =>
                    prompt.id === id ? { ...prompt, status: "Approved" } : prompt
                )
            );

            setReloadTrigger((prev) => !prev);  
        })
        .catch((err) => {
            toast.error(err);
        });
};

  const handleReject = (id) => {
    const payload = {
        status: PROMPT_STATUS.REJECT
    };

    postApiCall(`/v2/prompt/${id}`, payload)
        .then((data) => {
            showToasts("Audio Rejected");

           
            setPrompts((prevPrompts) =>
                prevPrompts.map((prompt) =>
                    prompt.id === id ? { ...prompt, status: "Rejected" } : prompt
                )
            );

            setReloadTrigger((prev) => !prev);  
        })
        .catch((err) => {
            toast.error(err);
        });
};

  const handleMultiDelete = () => {
        setIsMultiDelete(true);
        setEnableDeleteModal(true);
  };

  function handlePromptDelete(id) {
    checkAuth(setToastProps, setShowToast)
    setIsMultiDelete(false);
    setEnableDeleteModal(true);
    setDeletePromptId(id);
  }

  const [buttonDisable, setButtonDisable] = useState(false);
  
  const handleSelectAll = () => {
    if (selectedData.length === prompts.length) {
        setSelectedPrompt([]);
    } else {
        const allPromptsIds = prompts.map(prompt => prompt.id);
        setSelectedPrompt(allPromptsIds);
    }
  };

    useEffect( () => {
      if (confirmDelete) {
          postApiCall(`${BACKEND_API_BASE_URL}/v2/prompt/delete`, { promptIds: isMultiDelete ? selectedData :  [deletePromptId]})
        .then(onDeleteSuccess)
        .catch(onDeleteFail)
      }
    }, [confirmDelete]);
  
    function onDeleteSuccess(resp) {
      toast.success(resp)
      let updatedList;
      if (isMultiDelete) {
          updatedList = prompts.filter(val => !selectedData.includes(val.id)).map((val, key) => {
              val['key'] = key + 1;
              return val;
          });
          setSelectedPrompt([]);
      } else {
          updatedList = prompts
          .filter((val) => val.id != deletePromptId)
          .map((val, key) => {
            val["key"] = key + 1;
            return val;
          });
      }
      setPrompts(updatedList);
      setEnableDeleteModal(false);
      setDeletePromptId(undefined);
      setConfirmDelete(false); 
      fetchPrompts();
    }
  
    function onDeleteFail(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
        errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        toast.warning(`Unable to delete data center: ${err}`)
      }
      setConfirmDelete(false); 
     
    }


  const rowClassName = (data) => {
  return {
      'highlighted-row': selectedData.includes(data.id)
    };
  }



  const handleListen = (url) => {
    setAudioUrl(url);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setAudioUrl("");
  };

  const onError = (error) => {
    toast.warning(`Failed to load prompts: ${error}`)
    setShowToast(true);
  };

    const handleCheckboxToggle = (promptId) => {
    const isSelected = selectedData.includes(promptId);
    setSelectedPrompt(isSelected
        ? selectedData.filter(id => id !== promptId)
        : [...selectedData, promptId]);
  };

  const downloadFile = async (fileUrl, filename) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch the file');
      }
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || fileUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error while downloading the file:', error);
    }
  };


  const actionBodyTemplate = (rowData) => {
    const isApproved = rowData.status === "Approved";
    const isRejected = rowData.status === "Rejected";

    return (
        <div className="d-flex justify-space-between gap-2">
            <button
                className="btn-icons m-1"
                onClick={() => downloadFile(rowData.prompt_url, rowData.prompt_name)}
                style={{ marginLeft: '8px', border: 'none', background: 'none', padding: '0' }}
            >
                <i className="fa fa-download" aria-hidden="true" style={{ color: 'blue', fontSize: '24px'  }}></i>
            </button>
            <Button
                label="Listen"
                icon="pi pi-play"
                className="listen"
                id="btnprompt"
                onClick={() => handleListen(rowData.prompt_url)}
            />
           <Button
            label="Approve"
            className={`approve ${isApproved ? "disabled-btn" : ""}`}
            onClick={() => !isApproved && handleApprove(rowData.id)}
            disabled={isApproved}
           />
           
           <Button
            label="Reject"
            className={`reject ${isRejected ? "disabled-btn" : ""}`}
            onClick={() => !isRejected && handleReject(rowData.id)}
            disabled={isRejected}
           />

          {(isSuperAdmin || loggedInUserACL[MODULE_ACL.MANAGE_PROMPTS]?.delete) && (
            <DeleteIcon handleCallback={() => handlePromptDelete(rowData?.id)} />
          )}

        </div>
    );
};



  if (loading) {
    return <Loader />;
  }

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("Prompts", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  return (
    <>
     <div>
      <Toaster />
      <div className="card" style={{ marginTop: "20px" }}>
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">Manage Prompts</h4>
          <div className="d-flex justify-content-flex-end align-items-center">
            {
                                        prompts.length > 0 &&
                                        <Button
                                        label="Export Data"
                                        onClick={handleExport}
                                        className="p-button-active p-button-sm"
                                        style={{ marginBottom: "10px", marginLeft: "10px" }}
                                        disabled={buttonDisable}
                                      >
                                        &nbsp;
                  {buttonDisable && (
                    <span
                      className="spinner-border spinner-border-sm ml-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                                      </Button>
                                      }

          {(isSuperAdmin || loggedInUserACL[MODULE_ACL.MANAGE_PROMPTS]?.delete) && (
            <Button 
              label="Delete Selected" 
              onClick={handleMultiDelete} 
              className="p-button-danger p-button-sm" 
              style={{ marginBottom: '10px', marginLeft: '10px' }} 
              disabled={selectedData.length === 0} 
            />
          )}                                      

          </div>
        </div>
          <Form.Group style={{ height: "45px", width: "300px" }}>
            <Form.Control
              style={{
                height: "45px",
                width: "100%", // ensures it fits the parent Form.Group
                marginLeft: "10px",
                border: "1px solid #ced4da",
                fontSize: "15px",
                marginTop: "5px"
              }}
              placeholder="Search by Name..."
              type="text"
              maxLength={100}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              required
            />
          </Form.Group>

        <div className="card-body">
          <div className="scroll-container">
              <DataTable
                value={prompts}
                paginator
                rows={10}
                tableStyle={{ minWidth: "50rem" }}
                rowClassName={rowClassName}
              >
                <Column 
                      header={<Checkbox 
                      checked={selectedData.length === prompts.length && prompts.length > 0} 
                      onChange={handleSelectAll} 
                      />} 
                      headerStyle={{ width: '3rem' }} 
                      body={(rowData) => (
                      <Checkbox 
                        checked={selectedData.includes(rowData.id)} 
                        onChange={() => handleCheckboxToggle(rowData.id)} 
                      />
                      )} 
                    />
                <Column field="prompt_name" header="Name" filterPlaceholder="Search by name" />
                <Column field="prompt_duration" header="Duration" filterPlaceholder="Search by duration" />
                <Column field="status" header="Status" filterPlaceholder="Search by status" />
                <Column field="prompt_url" header="URL" filterPlaceholder="Search by URL" />
                <Column field="prompt_category" header="Category" filterPlaceholder="Search by category" />
                <Column field="creator.name" header="Created By" filterPlaceholder="Search by category" />
                <Column field="deletedBy.name" header="Deleted By" />
                <Column field="deleted_at" header="Deleted At"
                    body={(rowData) => {
                      if (!rowData.deleted_at) return
                      return new Date(rowData.deleted_at).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })
                    }}
                />
                <Column
                  header="Actions"
                  body={actionBodyTemplate}
                  style={{ textAlign: "center", width: "12rem" }}
                />

              </DataTable>
          </div>    
        </div>
      </div>

            <RenderDeleteModal 
               show={enableDeleteModal} 
               setShow={setEnableDeleteModal} 
               setConfirmDelete={setConfirmDelete} 
               isMultiDelete={isMultiDelete} 
               clearSelectedData={() => setSelectedPrompt([])}
            />

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
    <Dialog
        header="Audio Playback"
        visible={isModalVisible}
        style={{
          width: "40vw",
          position: "absolute",
          top: "10px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
        onHide={handleModalClose}
      >
        <audio controls style={{ width: "100%" }}>
          <source src={audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </Dialog>

      {/* LOTTIE MODEL FOR TOAST */}
      <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
                <Modal.Body className="text-center">
                    <h5>{toastMessage}</h5>
                    <LottieAnimation />
                </Modal.Body>
            </Modal>
    </>
   
  );
};

export default ManagePrompts;
